'use client';

import { c as _c } from "react/compiler-runtime";
import { useObserveEffect } from '@legendapp/state/react';
import { $React } from '@legendapp/state/react-web';
import type { DetailedHTMLProps, HTMLAttributes } from 'react';
import { observable } from '@legendapp/state';
import { useScrollDirection$ } from '@/hooks/useScrollDirection$';
import { cn } from '@/lib/cn';
export const headerState$ = observable({
  hidden: false,
  hasSubNav: false
});
export interface HeaderScrollAutoHideProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  hideMinScrollY?: number;
  disabled?: boolean;
}
export function HeaderScrollAutoHide(t0) {
  const $ = _c(17);
  let children;
  let classNameIn;
  let disabled;
  let props;
  if ($[0] !== t0) {
    const {
      children: t1,
      className: t2,
      hideMinScrollY,
      disabled: t3,
      ...t4
    } = t0;
    children = t1;
    classNameIn = t2;
    disabled = t3;
    props = t4;
    $[0] = t0;
    $[1] = children;
    $[2] = classNameIn;
    $[3] = disabled;
    $[4] = props;
  } else {
    children = $[1];
    classNameIn = $[2];
    disabled = $[3];
    props = $[4];
  }
  const t1 = !disabled;
  let t2;
  if ($[5] !== classNameIn || $[6] !== disabled || $[7] !== t1) {
    t2 = cn(classNameIn, "w-full transition-transform duration-300 transform-gpu z-50 top-0", {
      fixed: t1,
      absolute: disabled
    });
    $[5] = classNameIn;
    $[6] = disabled;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const className = t2;
  if (disabled) {
    let t3;
    if ($[9] !== children || $[10] !== className || $[11] !== props) {
      t3 = <div className={className} {...props}>{children}</div>;
      $[9] = children;
      $[10] = className;
      $[11] = props;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    return t3;
  }
  let t3;
  if ($[13] !== children || $[14] !== className || $[15] !== props) {
    t3 = <AutoHide className={className} {...props}>{children}</AutoHide>;
    $[13] = children;
    $[14] = className;
    $[15] = props;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  return t3;
}
export function AutoHide(t0) {
  const $ = _c(15);
  let children;
  let className;
  let hideMinScrollY;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      hideMinScrollY,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = hideMinScrollY;
    $[4] = props;
  } else {
    children = $[1];
    className = $[2];
    hideMinScrollY = $[3];
    props = $[4];
  }
  let t1;
  if ($[5] !== hideMinScrollY) {
    t1 = {
      minScrollY: hideMinScrollY
    };
    $[5] = hideMinScrollY;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const scrollDirection$ = useScrollDirection$(t1);
  let t2;
  if ($[7] !== scrollDirection$) {
    t2 = () => {
      headerState$.hidden.set(scrollDirection$.get() === "down");
    };
    $[7] = scrollDirection$;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  useObserveEffect(t2);
  let t3;
  if ($[9] !== className) {
    t3 = () => {
      const hide = headerState$.hidden.get();
      const hasSubNav = headerState$.hasSubNav.get();
      return cn(className, {
        "rounded-b-none shadow-none": hasSubNav,
        "-translate-y-full": hide,
        "translate-y-0": !hide
      });
    };
    $[9] = className;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== children || $[12] !== props || $[13] !== t3) {
    t4 = <$React.div $className={t3} {...props}>{children}</$React.div>;
    $[11] = children;
    $[12] = props;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}